import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icon-cart" }
const _hoisted_2 = { class: "fa-layers fa-fw" }
const _hoisted_3 = ["innerHTML"]

import {
  computed,
} from 'vue';
import { useStore } from 'vuex';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faShoppingCart } from '@fortawesome/pro-solid-svg-icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'IconCart',
  setup(__props) {

library.add(faShoppingCart);

const store = useStore();
const cartItemsCount = computed(() => store.getters['cart/countAll']);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-shopping-cart" }),
      _createElementVNode("span", {
        class: "fa-layers-counter",
        innerHTML: cartItemsCount.value
      }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})